import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL, systemFeatures } from '../data/atlas';
export function SystemSection() {
  return <section className="bg-warm px-4 py-6 sm:py-8" data-id="element-158" data-mp="3bideocp462aa">
      <div className="mx-auto max-w-4xl" data-id="element-159" data-mp="3bkzpcl7awxwq">
        <h2 className="text-center text-2xl leading-none text-navy sm:text-3xl" data-id="element-160" data-mp="36kbol7t9t2pb">
          The Complete 6-in-1 Prosthodontics Visual System
        </h2>

        <div className="mt-4 grid items-center gap-5 sm:grid-cols-2" data-id="element-161" data-mp="31mtng3lhvrrv">
          <a href={CHECKOUT_URL} className="block" data-id="element-162" data-mp="2wt7aeabf5lvj">
            <img src={BOX_IMAGE} alt="The six modules of PROSTHODONTICS VISUAL ATLAS™" className="mx-auto w-full max-w-xs drop-shadow-xl transition-transform duration-200 ease-soft hover:scale-[1.02]" data-id="element-163" data-mp="2ssf1xjadfl0b" />
          </a>

          <div data-id="element-164" data-mp="2iwby88zvfeb9">
            <p className="text-xl leading-none font-display uppercase text-navy sm:text-2xl" data-id="element-165" data-mp="2iw29spuh5f7o">
              🦷 PROSTHODONTICS VISUAL ATLAS™
            </p>
            <p className="mt-1 text-xs font-extrabold uppercase tracking-wide text-teal sm:text-sm" data-id="element-166" data-mp="13yg341ym2v18">
              The complete visual study system for dental students
            </p>
            <p className="mt-1 text-xs font-bold uppercase tracking-wide text-slate2" data-id="element-167" data-mp="u239t56zaj70">
              Dentures • RPDs • Fixed • Implants • Occlusion • Materials
            </p>

            <ul className="mt-3 space-y-1.5" data-id="element-168" data-mp="1mpz6wb0gmd4b">
              {systemFeatures.map(feature => <li key={feature} className="flex items-start gap-2 text-sm font-semibold leading-snug text-navy" data-id="element-169" data-mp="1roiqw5vhteu1">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-170" data-mp="1ctmb97lctp6x" />
                  {feature}
                </li>)}
            </ul>

            <CTAButton className="mt-4" data-id="element-171" data-mp="6bz6z01m6nh2">🦷 YES! I WANT THE COMPLETE SYSTEM</CTAButton>
          </div>
        </div>
      </div>
    </section>;
}